import { CalendarRoot } from "PFApp/booking/types/calendar_root";
import { PageTarget } from "PFTypes/saved_filters";

export const getSavedFiltersTarget = (calendarRoot: CalendarRoot) => {
  switch (calendarRoot) {
    case CalendarRoot.WorkforceProfiles:
      return PageTarget.BookingModuleWorkforce;
    case CalendarRoot.ProjectsEngagements:
      return PageTarget.BookingModuleProjectsEngagements;
    case CalendarRoot.ProjectsRoles:
      return PageTarget.BookingModuleProjectsRoles;
  }
};
